module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/focus--environment.4311061.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/focus--environment.pdf
// module id = EHZC
// module chunks = 10